import { gql } from "@apollo/client";

export const ADMIN_DASHBOARD_METRICS_QUERY = gql`
  query AdminDashboardMetrics {
    adminDashboardMetrics {
      totalCompanies
      totalAssets
      totalSites
      totalBuildings
      totalDocuments
      totalWorkOrders
      totalInspections
      topCompaniesByAssets {
        companyName
        assetCount
        workOrderCount
        inspectionCount
      }
    }
  }
`;

// Company Users Query
